import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useGetCleanRoomFlowRunsCount = ({
  crFlowId, crId, enabled, version = -1,
}) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  const {
    isLoading, isError, isSuccess, data,
  } = useQuery(
    ['Cr-Flow-Runs-Count', crFlowId, orgId, version],
    async () => axiosInstance.get(flow(orgId).runsCount(crId, crFlowId, version)),
    {
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
      select: (res) => res?.data?.count || undefined,
      retry: false,
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  return {
    isLoading, isError, isSuccess, data,
  };
};
